import { formatTenths } from '../decimal.ts';

/**
 * French coordinate-plane prompts (ADR 0085 §2, §5). A pair is written with a
 * semicolon, (3 ; 5), because the comma is the French decimal separator.
 */
export const coordinatePrompts = {
    slopeWord: 'pente',
    slopeFromPoints: (first: string, second: string) => `Quelle est la pente de la droite passant par ${first} et ${second} ?`,
    readPoint: (label: string) => `Quelles sont les coordonnées du point ${label} ?`,
    namePoint: (pair: string) => `Quel point a pour coordonnées ${pair} ?`,
    distance: (from: string, to: string) => `Quelle est la distance entre le point ${from} et le point ${to} ?`,
    quadrant: (label: string) => `Dans quel quadrant se trouve le point ${label} ?`,
    pair: (x: number, y: number) => `(${x} ; ${y})`,
    units: (count: number) => `${count} ${count === 1 ? 'unité' : 'unités'}`,
    /**
     * Polygons (ADR 0087 §3, §5). An area counted in grid squares is in
     * "unités d'aire", as French textbooks write it.
     */
    shapeName: (rectangle: boolean, corners: string) => `${rectangle ? 'du rectangle' : 'de la figure'} ${corners}`,
    area: (shape: string) => `Quelle est l'aire ${shape} ?`,
    perimeter: (shape: string) => `Quel est le périmètre ${shape} ?`,
    side: (side: string) => `Quelle est la longueur du côté ${side} ?`,
    /** Triangles (ADR 0092 §4) : la hauteur relative à la base. */
    triangleName: (corners: string) => `du triangle ${corners}`,
    base: (base: string) => `Quelle est la longueur de la base ${base} ?`,
    height: (base: string) => `Quelle est la hauteur relative à la base ${base} ?`,
    squareUnits: (count: number) => `${count} ${count === 1 ? "unité d'aire" : "unités d'aire"}`,
    /** Missing Corner (ADR 0094 §5). Each given corner is its letter and pair: "A (2 ; 3)". */
    missingCorner: (given: string[], missing: string) =>
        `Le rectangle ABCD a pour sommets ${given.slice(0, -1).join(', ')} et ${given[given.length - 1]}. Quelles sont les coordonnées de ${missing} ?`,
    /** Distance Between Points (ADR 0125 §3). A decimal comma and a space before the colon. */
    pointDistance: (from: string, to: string) => `Quelle est la distance entre le point ${from} et le point ${to}, au dixième près ?`,
    pointDistanceWhole: (horizontal: number, vertical: number, sum: number, distance: number) =>
        `${horizontal}² + ${vertical}² = ${sum} : ${distance} unités`,
    pointDistanceRounded: (horizontal: number, vertical: number, sum: number, tenths: number) =>
        `${horizontal}² + ${vertical}² = ${sum} : environ ${formatTenths(tenths, ',')} unités`,
};
